import styled from "styled-components/macro";

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  flex: 1;
`;

export const UploadArea = styled.div`
  border: 2px dotted ${({ theme }) => theme.greyLight};
  background: ${({ theme }) => theme.neutral50};
  border-radius: 4px;
  padding: 16px;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const FileThumbnailGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
`;

export const FileThumbnailCard = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.neutral200};
  overflow: hidden;
  background-color: ${({ theme }) => theme.neutral50};
`;

export const FileThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const FileThumbnailPdfFallback = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: ${({ theme }) => theme.redMedium};
`;

export const FileThumbnailRemoveButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.white};
  padding: 0;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;

export const InputContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const InputContentButton = styled.span`
  background-color: ${({ theme }) => theme.greenDark};
  border: none;
  border-radius: 24px;
  color: ${({ theme }) => theme.white};
  font-size: 16px;
  font-weight: 600;
  padding: 12px 24px;
  line-height: 24px;
  cursor: pointer;
`;

export const InputContentHintText = styled.span`
  color: ${({ theme }) => theme.greyMedium};
  font-size: 14px;
`;

export const SupportedFileTypesLabel = styled.div`
  color: ${({ theme }) => theme.neutral600};
  font-size: 14px;
  text-align: center;
`;

export const DropzoneErrorText = styled.div`
  margin-top: 10px;
  color: ${({ theme }) => theme.redDark};
`;
